import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';
import { mockFullLoggedInUser } from './mockFullLoggedInUser';

export const mockForumsModerator: MockResponseConfig = {
  ...mockFullLoggedInUser,
  UnifiedAccountQuery: (variables: Variables) => {
    const response = mockFullLoggedInUser.UnifiedAccountQuery(variables);

    return {
      data: {
        unified: {
          ...response.data.unified,
          account: {
            ...response.data.unified.account,
            isForumsModerator: true,
          },
        },
      },
    };
  },
};
